import { render } from "./ImportPeople.vue?vue&type=template&id=e48afd7e&scoped=true"
import script from "./ImportPeople.vue?vue&type=script&lang=js"
export * from "./ImportPeople.vue?vue&type=script&lang=js"

import "./ImportPeople.vue?vue&type=style&index=0&id=e48afd7e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48afd7e"]])

export default __exports__